import { appColors, BackrsIcon } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/system';

const DASHBOARD_STRINGS = appStrings.modules.dashboard;

type ProsperHeaderProps = Readonly<{
  uncompletedCount: number;
  levelOneCount: number;
  levelTwoCount: number;
}>;

export const ProsperHeader = ({
  uncompletedCount,
  levelOneCount,
  levelTwoCount,
}: ProsperHeaderProps) => {
  return (
    <Box sx={headerContainerStyle}>
      <Box sx={headerBoxStyle}>
        <Box sx={headerImageContainer}>
          <BackrsIcon name="ProsperLogo" alt="Prosper Logo" />
          <Typography variant="h3" sx={logoTextStyle}>
            {DASHBOARD_STRINGS.prosperPageName}
          </Typography>
        </Box>
        <Typography variant="body1" sx={headerTextStyle}>
          {DASHBOARD_STRINGS.header}
        </Typography>
      </Box>
      <Box sx={statsContainerStyle}>
        <Box sx={statsBoxStyle}>
          <BackrsIcon name="ModuleUncompleted" alt="Uncompleted" />
          <Typography variant="body1" sx={statsTextStyle}>
            {uncompletedCount}
          </Typography>
        </Box>
        <Box sx={statsBoxStyle}>
          <BackrsIcon name="ModuleLevelOne" alt="Level One" />
          <Typography variant="body1" sx={statsTextStyle}>
            {levelOneCount}
          </Typography>
        </Box>
        <Box sx={statsBoxStyle}>
          <BackrsIcon name="ModuleLevelTwo" alt="Level Two" />
          <Typography variant="body1" sx={statsTextStyle}>
            {levelTwoCount}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

const headerContainerStyle: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  alignItems: 'flex-start',
  gap: 2,
  mb: 4,
  boxSizing: 'border-box',
  '@media (max-width: 700px)': {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'flex-start',
    px: 2,
    mr: 0,
  },
};

const headerImageContainer: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  py: 2,
};

const headerTextStyle: SxProps<Theme> = {
  fontSize: 16,
  lineHeight: '26px',
  ml: 2,
  mr: 10,
  '@media (min-width: 1200px)': {
    ml: 8,
    mr: 2,
  },
  '@media (min-width: 1000px) and (max-width: 1199px)': {
    ml: 4,
    mr: 2,
  },
  '@media (max-width: 999px)': {
    mx: 1,
    mt: 1,
  },
};

const logoTextStyle: SxProps<Theme> = {
  fontSize: '36px',
  color: appColors.color.navy3,
  mb: 2,
};

const headerBoxStyle: SxProps<Theme> = {
  bgcolor: appColors.color.taupe1,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  height: '100%',
  pl: 5,
  pr: 10,
  mr: 2,
  borderRadius: '0 0 8px 8px',
  '@media (max-width: 1200px)': {
    pr: 8,
  },
  '@media (max-width: 1000px)': {
    alignItems: 'flex-start',
    flexDirection: 'column',
    mx: 0,
    ml: 4,
    px: 2,
    // mb: 2,
  },
  '@media (max-width: 700px)': {
    ml: 0,
  },
};

const statsContainerStyle: SxProps<Theme> = {
  bgcolor: appColors.color.taupe1,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  p: 4,
  boxSizing: 'border-box',
  borderRadius: '0 0 8px 8px',
  gap: 2,
  height: '100%',
  '@media (max-width: 700px)': {
    justifyContent: 'center',
    px: 0,
    py: 1,
    width: '100%',
  },
  '@media (max-width: 436px)': {
    flexDirection: 'column',
    gap: 1,
  },
};

const statsBoxStyle: SxProps<Theme> = {
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
};

const statsTextStyle: SxProps<Theme> = {
  fontSize: 16,
  lineHeight: '26px',
  fontWeight: 700,
};
